import gql from 'graphql-tag'

export const fetchUpdatePricesMutation = gql(`
mutation (
    $cart_id: String!, $delivery_date: String!, $date_popup: String!, $customer_order_number: String, $note_for_driver: String, $payment_method: String!,
    $outlet_order_type: String!, $delivery_method: String!, $flexDelivery: String!, $payment_method_title: String!, $empties_return: String!
) {
  updatePrices(
    input: {
      cart_id: $cart_id
      delivery_date: $delivery_date
      date_popup: $date_popup
      customer_order_number: $customer_order_number
      payment_method: $payment_method
      outlet_order_type: $outlet_order_type
      delivery_method: $delivery_method
      flexDelivery: $flexDelivery
      payment_method_title: $payment_method_title
      note_for_driver:  $note_for_driver
      empties_return: $empties_return
      #empties_data: $empties_data
      #no_empties_return: $no_empties_return
    }
  ) {
    success,
    message,
    can_proceed,
    status_message,
    minicart_status_message,
    payment_method,
    delivery_date,
    delivery_date_expired,
    order_type,
    delivery_method,
    ship_to_id,
    flexible_delivery,
    order_items{
        name,
        sku,
        packaging,
        your_price,
        volume,
        is_wishlist,
        image_main,
        row_total
        base_price

        list_price,
        discount,
        listprice_with_discount,
        excise_duty,
        custom_price,
        row_total_without_vat,
        row_total_list_price,
        row_total_discount,
        row_total_excise,
        row_total_with_vat,
        quantity
    }
    cart {
      note_for_driver
      customer_order_number
      grand_total_your_price
      grand_total_your_price_tax
      selected_payment_method {
        code
        title
      }
      cart_prices{
        grand_total_price
        grand_total_price_with_vat
        grand_total_discount
        grand_total_excise_duty
        grand_total_vat
        grand_total_final
      }
      empties {
        parent_product
        sku
        qty
        name
        number_of_bottles_gabbie
      }
      progress_bar_data {
        isFullTruck
        iMinimumOrderPallet
        iMaximumOrderPallet
        iMinimumOrderWeight
        iMaximumOrderWeight
        iMaximumOrderCash
        sOutletDeliveryMethod
        iTotalCartWeight
        iTotalCartPalletQty
      }
    },
    total_base_price,
    total_your_price,
    total_quantity
    #total_empties_deposit
   }
  }
`)
